/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */

import React, { PropTypes } from 'react';
import { FormattedRelative } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './services.css';
import pans from './panStyle.scss';
import Link from '../../components/Link';
import GrayPanel from '../../components/GrayPanel';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import fetch from '../../core/fetch';
import cx from 'classnames';
import _ from 'lodash';
import waiting from './waiting-wheel-300x300.gif';

import Select from 'react-select';

const isBrowser = typeof window !== 'undefined' && window !== null;
let Map, TileLayer, L, WMSTileLayer, Rectangle, GeoJSON, Pan, MyPan;

if (isBrowser) {
  Map = require('react-leaflet/lib/Map').default;
  TileLayer = require('react-leaflet/lib/TileLayer').default;
  WMSTileLayer = require('react-leaflet/lib/WMSTileLayer').default;
  Rectangle = require('react-leaflet/lib/Rectangle').default;
  GeoJSON = require('react-leaflet/lib/GeoJSON').default;
  L = require('leaflet');
}

const modalBlad = (props) =>
  <Modal>
    <Modal.Header className="bg-warning" closeButton>
      <Modal.Title>{props.title}</Modal.Title>
    </Modal.Header>
  </Modal>;

const ModalAlert = ({ title, bodyText, disableButton, name, ...props }) =>
  <Modal {...props}>
    <Modal.Header className="bg-warning" closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {bodyText}
      <br /><br />
      {!disableButton ? (
        <Button className="btn btn-warning pull-right" onClick={() => props.onHide(name)}>Zamknij</Button>
      ) : null}
      <br /><br />
    </Modal.Body>
  </Modal>;

class Services extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedParcels: [],
      additional_configs: {
        rowniez_wyrys: false,
      },
      isWorking: false,
      showError: false,
      jobId: null,
      jobStatus: null,
      showModal: true,
      modalTitle: "Generowanie dokumentu",
      modalBody: "Trwa generowanie twojego dokumentu",
      acceptApplication: false,
      selectedPrecint: '',
      parcels: null,
      errorTitle: '',
      signDoc: false,
      errorText: '',
      isShiftPressed: false,
      isCtrlPressed: false,
      startPoint: null,
      endPoint: null,
      isMouseEvent: false,
      ctrState: false,
      startSelectTime: 0,
      parcelFeatures: [],
      isSelectionEnabled: false,
      isMounted: false,
      parcelsGeom: {
        type: 'FeatureCollection',
        features: [],
      },
    };
  }

  bounds = Object.keys(this.props.mapstates[0]).reduce((previous, current) => {
    if (current === 'maxLat') previous['maxx'] = this.props.mapstates[0].maxLat;
    if (current === 'minLat') previous['minx'] = this.props.mapstates[0].minLat;
    if (current === 'maxLon') previous['maxy'] = this.props.mapstates[0].maxLon;
    if (current === 'minLon') previous['miny'] = this.props.mapstates[0].minLon;
    return previous;
  }, {'maxx': null, 'minx': null, 'maxy': null, 'miny': null});

  center = Object.keys(this.props.mapstates[0]).reduce((previous, current) => {
    if (current === 'centerLat') previous['lng'] = this.props.mapstates[0].centerLat;
    if (current === 'centerLon') previous['lat'] = this.props.mapstates[0].centerLon;
    return previous;
  }, {'lat': null, 'lng': null});

  zoom = this.props.mapstates[0].startZoom;

  componentDidMount = () => this.setState({ selectedPrecint: this.props.obreby[0].obreb, isMounted: true }, () => this.getParcelsForPrecint());
  onHide = (modal) => {
    this.setState({ showError: false });
  }
  onChangePrecint = (e) => this.setState({ selectedPrecint: e.target.value }, () => this.getParcelsForPrecint())

  onJobFinish = (resp) => {
    if (resp.redirect_url) {
      window.location.href = resp.redirect_url;
    } else {
      this.getJobOplataId(this.state.jobId);
    }
  }

  clearSelection = () => {
    this.setState({ parcelFeatures: [], selectedParcels: [] }, () => {
      this.mapka.leafletElement.setView(this.center, 12);
    });
  }

  getJobStatus = () => fetch(`${process.env.API_URL}/service/status/${this.state.jobId}`, { method: 'GET' })
    .then(r => r.json())
    .then(resp => this.setState(
      { jobStatus: resp },
      () => ((resp.status === 'started') ?
        setTimeout(this.getJobStatus, 100) : (resp.status === 'finished') ? this.onJobFinish(resp) : this.setState({ isWorking: false }))),
    );

  getParcelsForPrecint = () => fetch(`${process.env.API_URL}/eservices/${this.props.district}/${this.state.selectedPrecint}/parcels`, { method: 'GET' })
    .then(r => r.json())
    .then(resp => this.setState({
      parcels: resp.dzialki.map(v => {
        return { value: v, label: v, obreb: this.state.selectedPrecint };
      }),
    }));

  runService = () => {
    if (!this.state.acceptApplication || this.state.selectedParcels.length < 1) {
      this.setState({ showError: true, errorText: 'Błędnie wypełniony formularz', errorTitle: 'Popraw formularz a następnie spróbuj ponownie.' });
      return;
    } else {
      const data = {
        additional_configs: { ...this.state.additional_configs },
        dzialki: this.state.selectedParcels.map(v => v.label).join(';'),
        customer: this.props.userInfo,
        district: this.props.district,
        signDoc: this.state.signDoc,
      };
      if (this.props.serviceType === 'wypis_i_wyrys') {
        data.additional_configs.rowniez_wyrys = true;
      }
      fetch(`${process.env.API_URL}/eservices/service/${this.props.serviceType}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(r => {
          if (r.status === 200) {
            return r.json().then(resp => this.setState({ jobId: resp.message, isWorking: true }, this.getJobStatus));
          }
          // If we have server side error, then show message in response object
          throw r.text();
        })
        .catch(err => {
          return err;
        }) //.then(e => this.setState({ showError: true, errorText: e, errorTitle: 'Bład po stronie serwera.' }))

    }
  }

  getJobOplataId = jobId =>
    fetch(`${process.env.API_URL}/eservices/oplata?jobId=${jobId}`, { method: 'GET' })
    .then(r => {
      if (r.status === 200) {
        return r.json();
      }
      // If we have server side error, then show message in response object
      throw r.json().then(odp => this.setState({ showError: true, errorText: odp.message, errorTitle: 'Bład po stronie serwera.' }));
    })

  changeSignDoc = () => this.setState({ signDoc: !this.state.signDoc });

  changeApplicationState = () => this.setState({ acceptApplication: !this.state.acceptApplication });
  logChange = val => {
    let parcel = null;
    let isAdding = null;
    if (this.state.selectedParcels.length > val.length) {
      parcel = _.differenceWith(this.state.selectedParcels, val, _.isEqual)[0];
      isAdding = false;
    }
    if (this.state.selectedParcels.length < val.length) {
      parcel = _.differenceWith(val, this.state.selectedParcels, _.isEqual)[0];
      isAdding = true;
    }
    if (parcel) {
      this.setState({ selectedParcels: val, isMouseEvent: false }, isAdding ? () => this.addParcelToMap(parcel) : () => this.removeParcelFromMap(parcel));
    }
  }

  removeParcelFromMap = parcel => {
    this.setState({
      parcelFeatures: _.filter(this.state.parcelFeatures, v => {
        if (parcel.label === v.properties.nr_dzialki && parcel.obreb === v.properties.obreb) {
          return;
        }
        return v;
      }),
    }, this.refreshParcels);
  }

  addParcelToMap = parcel => fetch(`${process.env.API_URL}/eservices/${this.props.district}/parcel?nr_dzialki=${parcel.label}&precint=${parcel.obreb}`,
    { method: 'GET' })
    .then(r => {
      if (r.status === 200) {
        return r.json();
      }
      throw r;
    })
    .then(response => {
      this.setState({ parcelFeatures: this.state.parcelFeatures.concat(response) }, this.refreshParcels);
    });
  // ADD CATCH HERE

  refreshParcels = () => {
    if (this.state.selectedParcels.length > 0)  {
      if (this.dzialki.leafletElement) {
        this.dzialki.leafletElement.clearLayers();
        const data = {
          type: 'FeatureCollection',
          features: this.state.parcelFeatures,
        };
        const bounds = this.dzialki.leafletElement.addData(data).getBounds();
        // fit map only if it is not a mouse event
        if (!this.state.isMouseEvent) this.mapka.leafletElement.fitBounds(bounds);
      }
    } else {
      this.mapka.leafletElement.setView(this.center, 12)
    }
  };

  onMapClick = e => this.state.isSelectionEnabled ? fetch(`${process.env.API_URL}/eservices/${this.props.district}/parcel_in_point?lat=${e.latlng.lat}&lng=${e.latlng.lng}`,
    { method: 'GET' })
    .then(r => {
        if (r.status === 200) {
            return r.json()
        }
        throw r;
    })
    .then(response => {
      // IF YOU'RE HOLDING CTRL KEY THEN APPEND PARCEL ELSE
      // JUST SET STATE TO NEW PARCEL

      const parcel = {
        value: response.properties.nr_dzialki,
        label: response.properties.nr_dzialki,
        obreb: response.properties.obreb,
      };
      let isInListAlready = _.find(this.state.selectedParcels, v => v.value === response.properties.nr_dzialki);

      this.setState({
        isMouseEvent: true,
        selectedParcels: e.originalEvent.ctrlKey ? this.state.selectedParcels.concat(!isInListAlready ? parcel : []) : [parcel],
      }, () => {
        if (e.originalEvent.ctrlKey) {
          if (!isInListAlready) {
            this.addParcelToMap(parcel);
          }
        } else {
          this.setState({ parcelFeatures: [], selectedPrecint: parcel.obreb }, () => this.addParcelToMap(parcel));
        }
      });
    }) : null;


  onMouseDown = (e) => {
    if (this.state.isSelectionEnabled) {
      const d = new Date();
      this.setState({ startPoint: e.latlng, ctrState: e.originalEvent.ctrlKey, startSelectTime: d.getTime() });
    }
  };

  onMouseUp = (e) => {
    if (this.state.isSelectionEnabled) {
      this.setState({ ctrState: e.originalEvent.ctrlKey }, this.endSelection);
    }
  };
  onMouseMove = (e) => {
    if (this.state.isSelectionEnabled) {
      // if we have start point then we're drawing
      if (this.state.startPoint) {
        this.setState({ endPoint: e.latlng }, () => {
          if (this.state.ctrState !== e.originalEvent.ctrlKey) {
            this.endSelection();
          }
        });
      }
    }
  };

  endSelection = () => {
    // cleanup selection
    // ctrState: false,
    const d = new Date();
    const startP = this.state.startPoint;
    const endP = this.state.endPoint;
    this.setState({ startPoint: null, endPoint: null }, () => {
      const d = new Date();
      const selectTime = d.getTime() - this.state.startSelectTime;
      if (selectTime > 100 && endP) {
        fetch(`${process.env.API_URL}/eservices/${this.props.district}/parcel_in_box?latStart=${startP.lat}&lngStart=${startP.lng}&latEnd=${endP.lat}&lngEnd=${endP.lng}`,
          { method: 'GET' })
          .then(r => {
            if (r.status === 200) {
              return r.json()
            }
            throw r;
          })
          .then(response => {
            let parcels = [];
            for (let i = 0; i <= response.features.length - 1; i++) {
              const parcel = {
                value: response.features[i].properties.nr_dzialki,
                label: response.features[i].properties.nr_dzialki,
                obreb: response.features[i].properties.obreb,
              }
              parcels.push(parcel);
            }
            this.setState({ selectedParcels: parcels, parcelFeatures: response.features }, () => this.refreshParcels());
          });
      } else {
        console.info("rysowales cos ?");
      }
    });
  }

  onPan = () => {
      if (this.mapka) {
          this.setState({ isSelectionEnabled: !this.state.isSelectionEnabled }, () => {
            if (this.state.isSelectionEnabled) {
              this.mapka.leafletElement._container.style.cursor = 'crosshair';
              this.mapka.leafletElement.dragging.disable();
            } else {
              this.mapka.leafletElement._container.style.cursor = '';
              this.mapka.leafletElement.dragging.enable();
            }
          });
      }
  }

  mapRender = () => {
    let mapStyle = {
      width: '100%',
      height: '600px',
      border: 'solid 2px black',
      zIndex: '0',
    };
    const centr = [51.82769999999999, 19.24815];
    const mapa = (
      <Map
        ref={m => { this.mapka = m; }}
        center={this.center}
        style={mapStyle}
        zoom={this.zoom}
        onLoad={() => this.onMapLoad()}
        onClick={(e) => this.onMapClick(e)}
        onKeyDown={(e) => this.onKeyDown(e)}
        onKeypress={(e) => this.onkeypress(e)}
        onMousedown={(e) => this.onMouseDown(e)}
        onMouseup={(e) => this.onMouseUp(e)}
        onMousemove={(e) => this.onMouseMove(e)}
        animate
      >
        <TileLayer
          url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
        />
        {(this.props.serviceType === 'WypisIWyrysZeStudium' || this.props.serviceType === 'ZaswiadczenieStudium' || this.props.serviceType === 'Informacj') ?
          <WMSTileLayer
            url={`https://e-spdp.pl/oldihub/ows/${this.props.prefix}?`}
            format={'image/png'}
            transparent
            layers={'SKiUZP'}
          />
        :
          <TileLayer
            ref={m => { this.tilelayer = m; }}
            url={`https://e-spdp.pl/oldihub/wmts/${this.props.prefix}/webmercator/{z}/{x}/{y}.png`}
            layer={`${this.props.prefix}`}
            format='image/png'
            crs={L.CRS.EPSG900913}
            tileSize={1024}
          />
        }
        <WMSTileLayer
          url={`${process.env.GEOSERVER}/${this.props.prefix}/wms?`}
          format={'image/png'}
          transparent
          layers={'granica_gminy'}
        />
        <WMSTileLayer
          url={`${process.env.GEOSERVER}/${this.props.prefix}/wms?`}
          format={'image/png'}
          transparent
          layers={'dzialki_ewidencyjne'}
        />
        {/* <WMSTileLayer
          url={'http://37.187.154.62:8080/geoserver/gmina_aleksandrow_lodzki/wms?'}
          format={'image/png'}
          transparent
          layers={'obreby_ew'}
        /> */}
        {this.state.parcelFeatures.length > 0 ? (
          <GeoJSON
            ref={m => { this.dzialki = m; }}
            cursor={'crosshair'}
            data={{
              type: 'FeatureCollection',
              features: this.state.parcelFeatures,
            }}
          />
        ) : null }

        {/*selection rectangle*/}
        {(this.state.startPoint && this.state.endPoint) ? (
          <Rectangle
            bounds={[[this.state.startPoint.lat, this.state.startPoint.lng], [this.state.endPoint.lat, this.state.endPoint.lng]]}
          />
        ) : null }
      </Map>
    );
    this.mapa = mapa;
    if (this.mapka) {
      // this.mapka.leafletElement._container.style.cursor = 'crosshair';
      // this.mapka.leafletElement.dragging.disable();
      this.mapka.leafletElement.setMinZoom(11);

      //L.DomEvent.on(this.mapka.leafletElement, 'keydown', this.onKeyDown, this)
    }

    return (
        <div className="row" style={{ padding: '20px' }}>
          <button onClick={() => this.onPan()} className={this.state.isSelectionEnabled ? 'pan_btn leaflet-control-zoom-in leaflet-control-zoom leaflet-bar' : 'pan_btn leaflet-control-zoom-in leaflet-control-zoom leaflet-bar active'} type="submit" />
          <button onClick={() => this.onPan()} className={!this.state.isSelectionEnabled ? 'select_btn leaflet-control-zoom-in leaflet-control-zoom leaflet-bar' : 'select_btn leaflet-control-zoom-in leaflet-control-zoom leaflet-bar active'} type="submit" />
          {mapa}
      </div>
    );
  }

  getHeaderText = serviceType => {
    if (serviceType==='uproszczony_wyrys') return 'Uproszczony wyrys z miejscowego planu zagospodarowania przestrzennego';
    if (serviceType==='wypis_i_wyrys') return 'Wypis i wyrys z miejscowego planu zagospodarowania przestrzennego';
    if (serviceType==='WypisIWyrysZMpzp') return 'Wypis i wyrys z miejscowego planu zagospodarowania przestrzennego';
    if (serviceType==='ZaswiadczenieMPZP') return 'Zaświadczenie z miejscowego planu zagospodarowania przestrzennego';
    return 'Header'
  }

  getMotionText = serviceType => {
    if (serviceType==='uproszczony_wyrys')    return 'wyrysu';
    if (serviceType==='wypis_i_wyrys')        return 'wypisu i wyrysu';
    if (serviceType==='WypisIWyrysZMpzp')     return 'wypisu i wyrysu';
    if (serviceType==='ZaswiadczenieMPZP')    return 'zaświadczenia';
    return "wypisu";
  }


  render() {
    // wypis_i_wyrys oraz urposzczony_wyrys
    const serviceType = {
      uproszczony_wypis: 'Uproszczony wypis',
      wypis_i_wyrys: 'Wypis i wyrys',
    };

    // layout classes
    const leftCol = 'col-sm-2';
    const labelCol = 'col-sm-2';
    const inputCol = 'col-sm-6';
    const rightCol = 'col-sm-2';

    // really simple styles
    const labelStyle = { marginTop: '.5rem' };
    const rowStyle = { marginTop: '15px' };

    // Translate eboi user info object keys to displayable labels
    const formDict = {
      FirstName: {
        label: 'Imię',
      },
      LastName: {
        label: 'Nazwisko',
      },
      FullName: {
        label: 'Nazwa wnioskodawcy',
      },
      AddressCity: {
        label: 'Miejscowość',
      },
      AddressStreet: {
        label: 'Ulica',
      },
      AddressFlat: {
        label: 'Numer lokalu',
      },
      AddressNumber: {
        label: 'Numer budynku',
      },
      AddressZipCode: {
        label: 'Kod pocztowy',
      },
      Email: {
        label: 'Email',
      },
    };

    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className="row" style={{ marginTop: '15px' }}>
            <h2>{this.getHeaderText(this.props.serviceType)}</h2>
            <GrayPanel title="Dane wnioskodawcy: ">

              {/* map dictionary to userInfo from props to row, whereas dict key is maps to userInfo key and label is displayable label in ui*/}
              {Object.keys(formDict).map((v, i) => {
                return (
                  <div className="row" key={i} style={rowStyle}>
                    <div className={leftCol} />
                    <div className={labelCol}>
                      <label style={labelStyle}>{formDict[v].label}</label>
                    </div>
                    <div className={inputCol}>
                      <input className="form-control" value={this.props.userInfo[v] ? this.props.userInfo[v] : ''} disabled />
                    </div>
                    <div className={rightCol} />
                  </div>
                );
              })}

            </GrayPanel>
            <GrayPanel title="Wybierz działki">
              <div className="row">
                <div className={leftCol} />
                <div className={labelCol}>
                  <label htmlFor="dzialki" style={labelStyle} >Obręby</label>
                </div>
                <div className={inputCol}>
                  <select
                    name="obreby"
                    className="form-control"
                    value={this.state.selectedPrecint}
                    onChange={(e) => this.onChangePrecint(e)}
                  >
                    {this.props.obreby.map((v, i) => {
                      return <option key={i} value={v.obreb}>{v.nazwa_obrebu}</option>
                    })}
                  </select>
                </div>
                <div className={rightCol} />
              </div>

              <div className="row">
                <div className={leftCol} />
                <div className={labelCol}>
                  <label htmlFor="dzialki" style={labelStyle} >Działki</label>
                </div>
                <div className={inputCol}>
                  <Select
                    multi
                    name="form-field-name"
                    value={this.state.selectedParcels}
                    options={this.state.parcels}
                    clearable={false}
                    onChange={this.logChange}
                    onBlur={event => event.preventDefault()}
                    optionClassName="needsclick"
                    blurInputOnSelect={false}
                  />

                </div>
                <div className={rightCol}>
                  <button onClick={() => this.clearSelection()} className="btn btn-default" type="submit"><strong>Odznacz wszystko</strong></button>
                </div>
              </div>

              {this.state.isMounted ? this.mapRender() :
                <div style={{ textAlign: 'center !important', marginTop: '100px', marginBottom: '100px'}}><img alt="Loader" src={waiting} /></div>
              }
            </GrayPanel>

            {/*
            <GrayPanel title="Wybór typu usługi">
              <div className={leftCol} />
              <div className={labelCol}>
                <label htmlFor="typ" style={labelStyle}>Usługa</label>
              </div>
              <div className={inputCol}>
                <select
                  type="text"
                  value={this.props.serviceType}
                  className="form-control"
                  disabled
                >
                  {Object.keys(serviceType).map((v, i) => {
                    return <option key={i} value={v}>{serviceType[v]}</option>;
                  })}
                </select>
              </div>
              <div className={rightCol} />
            </GrayPanel>
            */}

            <GrayPanel title="Akceptuj">
              <div className={s.subtitle}>
                <input
                  name="isDefault"
                  type="checkbox"
                  value={this.state.signDoc}
                  onChange={this.changeSignDoc}
                /> &nbsp;&nbsp;&nbsp;
                Podpisz dokument podpisem elektronicznym ePUAP</div>
              <div className={s.subtitle}>
                <input
                  name="isDefault"
                  type="checkbox"
                  value={this.state.acceptApplication}
                  onChange={this.changeApplicationState}
                /> &nbsp;&nbsp;&nbsp;
                Na podstawie art. 30 ust. 1 ustawy z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym
                wnioskuję o wydanie {this.getMotionText(this.props.serviceType)} z miejscowego planu zagospodarowania przestrzennego dla wskazanego terenu.</div>
            </GrayPanel>
            {/*<div className="col-sm-2" />*/}
          </div>

          <div className="row">
            <div className="col-sm-12">
              <button type="submit" className={cx('pull-right', s.buttonSubmit)} onClick={() => this.runService()}>Uruchom</button>
            </div>
          </div>
          {/* {this.state.jobStatus ? (
            <div className="row">
              {this.state.jobStatus.status}
            </div>
          ) : null} */}
        </div>
        <ModalAlert
          title={this.state.modalBody}
          bodyText={this.state.modalBody}
          show={this.state.isWorking}
          name="isWorkingModal"
          onHide={this.onHide}
          disableButton
        />
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

      </div>

    );
  }
}


export default withStyles(pans)(withStyles(s)(Services));



// WEBPACK FOOTER //
// src/routes/services/services.js